let swipers = {
  catalogHeader: {
    slider: false,
    elem: $(".js-slider-catalog-header"),
    active: false,
    query: false,
    tooltipOpen: false,
    options: {
      autoplay: false,
      slidesPerView: 5,
      slidesPerGroup: 5,
      simulateTouch: false,
      allowTouchMove: false,
      loop: false,
      // effect: 'fade',
      pagination: {
        el: ".js-slider-catalog-header-dots",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-slider-catalog-header-next",
        prevEl: ".js-slider-catalog-header-prev",
        disabledClass: "is-disabled",
        hiddenClass: "is-hidden",
      },
      breakpoints: {
        1199: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1023: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        599: {
          allowTouchMove: true,
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 10,
        },
      },
      on: {
        init: function () {
          swipers.catalogHeader.active = true;
        },
        slideChange: function () {
          setTimeout(function () {
            bLazy.revalidate();
          }, 100);
        },
      },
    },
  },
};

let rangeSliders = {};

const $view = $("#filter-view");
const $fakeView = $(".js-fake-view");

function renderMultiselect() {
  $(".js-multiselect")
    .not(".is-loaded")
    .multiselect({
      templates: {
        button: `
                <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                    <i aria-hidden="true" class="ico ico-caret-down"></i>
                    <span class="multiselect-selected-text"></span>
                </button>
            `,
      },
      buttonClass: "c-btn",
      enableHTML: true,
    });

  $(".js-multiselect").addClass("is-loaded");

  $(".js-multiselect-order")
    .not(".is-loadeed")
    .multiselect({
      templates: {
        button: `
                <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                    <i aria-hidden="true" class="ico ico-sort"></i>
                    <span class="multiselect-selected-text"></span>
                    <i aria-hidden="true" class="ico ico-caret-down"></i>
                </button>
            `,
      },
      buttonClass: "c-btn",
      enableHTML: true,
      buttonText: function (options, select) {
        const $orderSelect = $(".js-multiselect-order"),
          selectedValue = $(options).text(),
          emptyTitle = $orderSelect.data("empty-title"),
          isFiltered = $orderSelect.data("is-filtered"),
          isLoaded = $orderSelect.hasClass("is-loaded");

        let buttonTitle = selectedValue;

        if (!isLoaded && !isFiltered) {
          buttonTitle = emptyTitle;
        }

        return buttonTitle;
      },
    });

  $(".js-multiselect-order").addClass("is-loaded");
}

function updateRangeCallback(selectors, values, sliderInstance) {
  const $from = $(selectors.from),
    $to = $(selectors.to),
    fromVal = $from.val(),
    toVal = $to.val(),
    minValue = sliderInstance.options.range.min[0],
    maxValue = sliderInstance.options.range.max[0];

  if (minValue == values[0] && maxValue == values[1]) {
    $from.val("").removeAttr("value");
    $to.val("").removeAttr("value");

    Filter.submit();

    return true;
  }

  $from.val(values[0]);
  $to.val(values[1]);

  if (!fromVal && !toVal) {
    $to.trigger("change");
  } else if (fromVal === values[0]) {
    $to.trigger("change");
  } else if (toVal === values[1]) {
    $from.trigger("change");
  }
}

function createRangeSliders() {
  $(".js-range-price").each(function () {
    const $elem = $(this),
      $slider = $elem.find(".range-slider__slider"),
      maxValue = Number($elem.attr("data-max")),
      minValue = Number($elem.attr("data-min")),
      fromValue = Number($elem.attr("data-from")),
      toValue = Number($elem.attr("data-to"));

    rangeSliders["price"] = noUiSlider.create($slider[0], {
      start: [fromValue, toValue],
      range: {
        min: [minValue],
        max: [maxValue],
      },
      margin: 1,
      connect: true,
      tooltips: [wNumb({ decimals: 0 }), wNumb({ decimals: 0 })],
      step: 1,
    });

    rangeSliders["price"].on("change", function (values, handle) {
      updateRangeCallback(
        {
          from: '[name="filter[price][from]"]',
          to: '[name="filter[price][to]"]',
        },
        values,
        this
      );
    });
  });

  $(".js-range-properties").each(function () {
    const $elem = $(this),
      $slider = $elem.find(".range-slider__slider"),
      maxValue = Number($elem.attr("data-max")),
      minValue = Number($elem.attr("data-min")),
      fromValue = Number($elem.attr("data-from")),
      toValue = Number($elem.attr("data-to")),
      id = $elem.data("id");

    if (!rangeSliders["properties"]) {
      rangeSliders["properties"] = {};
    }

    rangeSliders["properties"][id] = noUiSlider.create($slider[0], {
      start: [fromValue, toValue],
      range: {
        min: [minValue],
        max: [maxValue],
      },
      margin: 1,
      connect: true,
      tooltips: [wNumb({ decimals: 0 }), wNumb({ decimals: 0 })],
      step: 1,
    });

    rangeSliders["properties"][id].on("change", function (values, handle) {
      updateRangeCallback(
        {
          from: '[name="filter[properties][' + id + '][from]"]',
          to: '[name="filter[properties][' + id + '][to]"]',
        },
        values,
        this
      );
    });
  });
}

function toggleFilter() {
  const $subFilter = $(".js-target-filter"),
    $subFilterTrigger = $(".js-trigger-filter"),
    $triggerIcon = $(".js-filter-icon"),
    $filterWrapper = $(".js-filter-wrapper"),
    $body = $("body");

  if ($subFilter.hasClass("is-active")) {
    $subFilter.removeClass("is-active");
    $subFilterTrigger.removeClass("is-active");
    $filterWrapper.removeClass("is-open");

    $triggerIcon.removeClass("ico-cross");
    $triggerIcon.addClass("ico-filter");

    unfreezeScroll();
    $body.removeClass("is-overlayed");
  } else {
    $subFilter.addClass("is-active");
    $subFilterTrigger.addClass("is-active");
    $filterWrapper.addClass("is-open");

    $triggerIcon.removeClass("ico-filter");
    $triggerIcon.addClass("ico-cross");

    $body.addClass("is-overlayed");
    freezeScroll();
  }
}

function updateFilterBubbles() {
  const $bubblesWrappers = $(".js-filter-bubbles-wrapper");

  for (const bubblesWrapper of $bubblesWrappers) {
    const $bubblesWrapper = $(bubblesWrapper);
    const $bubblesItems = $bubblesWrapper.find(".js-filter-bubbles-item");
    const $bubblesReset = $bubblesWrapper.find(".js-filter-bubbles-reset");

    $bubblesWrapper.data("count", $bubblesItems.length);

    if ($bubblesItems.length < 1) {
      $bubblesReset.remove();
      $bubblesWrapper.removeClass("is-visible");
    } else {
      $bubblesWrapper.addClass("is-visible");
    }
  }
}

function renderFilterBubbles() {
  updateFilterBubbles();

  rEvent.on("FilterBubbles.afterRefresh", function () {
    updateFilterBubbles();
  });

  rEvent.on("FilterBubbles.returnedRefresh", function () {
    updateFilterBubbles();
  });

  $("body").on("change", '.c-aside-filter [type="checkbox"]', function () {
    updateFilterBubbles();
  });

  // filter bubbles reset hide
  $("body").on("click", ".js-filter-bubbles-item", function () {
    const filterKey = this.dataset.filterKey;
    const filterValue = this.dataset.filterValue;

    $(
      `.js-filter-bubbles-item[data-filter-key="${filterKey}"][data-filter-value="${filterValue}"]`
    ).remove();

    updateFilterBubbles();

    setTimeout(function () {
      updateFilterBubbles();
    }, 1);
  });

  $("body").on("click", ".js-filter-bubbles-reset", function (event) {
    event.preventDefault();

    filterReset();
  });
}

function setFilterImage() {
  const $image = $(".js-filter-main-image"),
    imageSrc = $(".js-tabs-trigger.is-active").data("image");

  $image.css(
    "background-image",
    $image.is(":visible") && imageSrc ? "url(" + imageSrc + ")" : ""
  );
}

rEvent.on("Filter.beforeSubmit", function () {
  const $priceFrom = $('[name="filter[price][from]"]');
  const $priceTo = $('[name="filter[price][to]"]');

  $priceFrom.prop("disabled", false);
  $priceTo.prop("disabled", false);

  if (!$priceFrom.val() && !$priceTo.val()) {
    $priceFrom.prop("disabled", true);
    $priceTo.prop("disabled", true);
  }
});

rEvent.on("Filter.submited", function () {
  $('[name="filter[price][from]"]').prop("disabled", false);
  $('[name="filter[price][to]"]').prop("disabled", false);
});

function filterReset() {
  const $rangePrice = $(".js-range-price");
  const maxValue = Number($rangePrice.attr("data-max"));
  const minValue = Number($rangePrice.attr("data-min"));

  $(".js-filter-reset-button").click();

  $rangePrice
    .find(".range-slider__slider")[0]
    .noUiSlider.set([minValue, maxValue]);

  updateFilterBubbles();
}

$(function () {
  checkSliders(swipers);
  renderMultiselect();
  renderFilterBubbles();
  createRangeSliders();

  tippy(".js-filter-tippy", {
    arrow: true,
    theme: "filter",
    performance: true,
    maxWidth: "calc(100% - 30px)",
  });

  $(".js-catalog-header-subcategories .js-category-item.is-more").on(
    "click",
    function () {
      $(this).toggleClass("is-open");
      $(".js-catalog-header-subcategories")
        .find("[data-hidden]")
        .toggleClass("is-hidden");

      $(this).blur();
    }
  );

  $(document).on("mouseover", ".js-products-listing-item", function () {
    $(this).addClass("is-hovered");
  });

  $(document).on("mouseleave", ".js-products-listing-item", function () {
    setTimeout(() => {
      $(this).removeClass("is-hovered");
    }, 175);
  });

  $(".js-trigger-filter, .js-close-filter").on("click", function (e) {
    e.preventDefault();

    if (!$(this).hasClass("is-disabled")) {
      toggleFilter();
      setFilterImage();

      setTimeout(() => {
        bLazy.revalidate();
        setFilterImage();
      }, 700);
    }
  });

  $(".js-filter-show-results").on("click", function () {
    toggleFilter();
  });

  $(".js-close-filter, .js-filter-show-results").on("click", function () {
    if ($(window).scrollTop() < $(".catalog-filter__bubbles").offset().top) {
      $(".catalog-filter__bubbles").slideHere(0, 300);
    }
  });

  $(".js-tabs-content").on("ruiTabShowed", function (event) {
    event.preventDefault();

    setTimeout(() => bLazy.revalidate(), 700);
  });

  $(".js-tabs-trigger").on("click", () => {
    setFilterImage();

    if ($(window).scrollTop() > $(".js-target-filter").offset().top) {
      $(".js-target-filter").slideHere(0, 150);
    }

    $(".js-subfilter-content").scrollTop(0);
  });

  rEvent.on("Window.resized", function () {
    checkSliders(swipers);
  });

  rEvent.on("Listing.changeView", function () {
    const $view = $("#filter-view"),
      value = $view.val();

    $(".js-fake-view").removeClass("is-active");
    $(".js-fake-view#" + value).addClass("is-active");

    $(".products")
      .removeClass("products--block")
      .removeClass("products--row")
      .removeClass("products--grid");
    $(".products").addClass("products--" + value);

    $(".products .js-thumb").removeClass("is-row").removeClass("is-grid");
    $(".products .js-thumb").addClass("is-" + value);

    $(".products .js-thumb").addClass("is-view-changing");

    setTimeout(function () {
      $(".products .js-thumb").removeClass("is-view-changing");
    }, 10);
  });

  $fakeView.on("click", function () {
    const viewValue = $(this).data("value");

    $view.val(viewValue).change();
  });
});

const categoriesToggle = document.querySelector(".js-categories-toggle");

if (categoriesToggle) {
  categoriesToggle.addEventListener("click", function () {
    const $categoriesWrapper = document.querySelector(".js-categories-wrapper");

    $categoriesWrapper.classList.toggle("is-active");
  });
}
